import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useOauth from 'data/oauth/use-oauth';

export default function Logout() {
	const navigate = useNavigate();
	const { clearOauth } = useOauth();

	useEffect( () => {
		clearOauth();
		navigate( '/', { replace: true } );
	}, [] );

	return null;
}
